export default __webpack_public_path__ + "static/media/LO08.ec3a03a6.mp3";